import * as React from 'react'
import type { SvgIconProps } from '@mui/material'
import { BaseIcon } from '../BaseIcon'
export const UserIcon = (props: SvgIconProps) => (
  <BaseIcon fill="none" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 19v2h18v-2s-1.705-3.596-6.267-4.689a11.7 11.7 0 0 0-2.82-.31 11.6 11.6 0 0 0-2.762.339C4.676 15.465 3 19 3 19m6.46-6.774a4.46 4.46 0 0 0 2.54.73 4.473 4.473 0 0 0 4.39-4.477 4.478 4.478 0 1 0-6.93 3.747M18.617 19H5.384c.24-.302.554-.65.95-.998C7.447 17.024 9.24 16 12 16s4.554 1.024 5.665 2.002c.397.349.711.697.95.998M9.434 8.478a2.478 2.478 0 1 0 4.956 0 2.478 2.478 0 0 0-4.956 0"
      clipRule="evenodd"
    />
  </BaseIcon>
)
